import React from "react";
import Leave from './Leave';

const Renderer = React.memo(() => {
    return (
        <Leave />
    )
});

export default Renderer;